import {Button, InputGroup} from "react-bootstrap";
import {useState} from "react";


function RoverWaterSourcePlacement( {rainMap, defaultLatLng, onSave} ) {

    const [waterPos, setWaterPos] = useState(defaultLatLng);

    return (
        <form>
            <InputGroup>
                <input type={"number"} defaultValue={defaultLatLng.lat} step={0.00005} onChange={event => {
                    let pos = waterPos;
                    pos.lat = event.target.value;
                    setWaterPos(pos);
                    rainMap.setWaterSourcePos(pos);
                }} />
                <input type={"number"} defaultValue={defaultLatLng.lng} step={0.00005} onChange={event => {
                    let pos = waterPos;
                    pos.lng = event.target.value;
                    setWaterPos(pos);
                    rainMap.setWaterSourcePos(pos);
                }} />
            </InputGroup>
            <Button onClick={event => {
                onSave(waterPos);
            }}>
                Save
            </Button>
        </form>
    );
}



export default RoverWaterSourcePlacement;
